export default "__VITE_ASSET__iz2NDSb2__"